
import React from "react";

const SplashScreen = () => {
  return (
    <div className="centered-img" id="splash">
      <img id="try" className="splashimg" src="/img/co.svg" alt="Elemental Value Co" />
    </div>
  );
};

export default SplashScreen;
